// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Switcher-module--cds--assistive-text--56cef";
export var cdsHideFeedback = "Switcher-module--cds--hide-feedback--20d2d";
export var cdsShowFeedback = "Switcher-module--cds--show-feedback--75b23";
export var cdsSkeleton = "Switcher-module--cds--skeleton--c18cb";
export var cdsVisuallyHidden = "Switcher-module--cds--visually-hidden--72048";
export var divider = "Switcher-module--divider--7e12e";
export var link = "Switcher-module--link--67901";
export var linkDisabled = "Switcher-module--link--disabled--6572e";
export var nav = "Switcher-module--nav--24bef";
export var open = "Switcher-module--open--7c4b1";